export interface RecentPurchase {
  nombre: string
  producto: string
  tiempo: string
}

export const recentPurchases: RecentPurchase[] = [
  {
    nombre: 'Andrés Molina Vargas',
    producto: 'Megapack PRO + Asistente de IA',
    tiempo: 'hace 10 minutos',
  },
  {
    nombre: 'Sofía Herrera Castillo',
    producto: 'Megapack PRO + Asistente de IA',
    tiempo: 'hace 27 minutos',
  },
  {
    nombre: 'Mateo Rojas Calderón',
    producto: 'Megapack PRO + Asistente de IA',
    tiempo: 'hace 1 hora',
  },
  {
    nombre: 'Valentina Cruz Méndez',
    producto: 'Megapack PRO + Asistente de IA',
    tiempo: 'hace 43 minutos',
  },
  {
    nombre: 'Daniela Paredes López',
    producto: 'Megapack PRO + Asistente de IA',
    tiempo: 'hace 1 hora y 15 minutos',
  },
  {
    nombre: 'Sebastián Navarro León',
    producto: 'Megapack PRO + Asistente de IA',
    tiempo: 'hace 8 minutos',
  },
  {
    nombre: 'Camila Torres Vidal',
    producto: 'Megapack PRO + Asistente de IA',
    tiempo: 'hace 2 horas',
  },
  {
    nombre: 'Nicolás Ramírez Peña',
    producto: 'Megapack PRO + Asistente de IA',
    tiempo: 'hace 34 minutos',
  },
  {
    nombre: 'Lucía Fernández Salas',
    producto: 'Megapack PRO + Asistente de IA',
    tiempo: 'hace 1 hora y 48 minutos',
  },
  {
    nombre: 'Alejandro Méndez Ríos',
    producto: 'Megapack PRO + Asistente de IA',
    tiempo: 'hace 20 minutos',
  },
]
